import axios from 'axios'
import { authHeader, baseUrl } from '../../utils'
import {
	CREATE_SICKBAY_RECORD,
	CREATING_SICKBAY_RECORD,
	GETTING_SICKBAY_RECORD,
	GETTING_SICKBAY_RECORDS,
	GETTING_SICKBAY_STATS,
	GET_SICKBAY_RECORD,
	GET_SICKBAY_RECORDS,
	GET_SICKBAY_STATS,
	SET_SUCCESS,
	SICKBAY_ERROR,
	UPDATE_SICKBAY_RECORD,
	UPDATING_SICKBAY_RECORD
} from '../types'

export const fetchSickBayRecords = (filterString, page, perPage) => async (dispatch) => {
	try {
		const headers = authHeader()

		let url = `${baseUrl}/sickbay/records`

		if (filterString && filterString !== '') {
			url += `${url.includes('?') ? '&' : '?'}${filterString}`
		}

		if (page && page !== '') {
			url += `${url.includes('?') ? '&' : '?'}page=${page}`
		}

		if (perPage && perPage !== '') {
			url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
		}

		dispatch({
			type: GETTING_SICKBAY_RECORDS,
			payload: true
		})

		const response = await axios.get(url, { headers })

		dispatch({
			type: GET_SICKBAY_RECORDS,
			payload: response?.data?.data || response?.data
		})
	} catch (error) {
		dispatch({
			type: SICKBAY_ERROR,
			error
		})
	}
}

export const fetchSickBayRecord = (id) => async (dispatch) => {
	try {
		const headers = authHeader()

		dispatch({
			type: GETTING_SICKBAY_RECORD,
			payload: true
		})

		const response = await axios.get(`${baseUrl}/sickbay/records/${id}`, { headers })

		dispatch({
			type: GET_SICKBAY_RECORD,
			payload: response?.data?.data || response?.data
		})
	} catch (error) {
		dispatch({
			type: SICKBAY_ERROR,
			error
		})
	}
}

export const createSickBayRecord = (payload) => async (dispatch) => {
	try {
		const headers = authHeader()

		dispatch({
			type: CREATING_SICKBAY_RECORD,
			payload: true
		})

		const response = await axios.post(`${baseUrl}/sickbay/records`, payload, { headers })

		dispatch({
			type: CREATE_SICKBAY_RECORD,
			payload: response?.data?.data || response?.data
		})

		dispatch({
			type: SET_SUCCESS,
			payload: 'Sickbay visit recorded successfully'
		})
	} catch (error) {
		dispatch({
			type: SICKBAY_ERROR,
			error
		})
	}
}

export const updateSickBayRecord = (id, payload) => async (dispatch) => {
	try {
		const headers = authHeader()

		dispatch({
			type: UPDATING_SICKBAY_RECORD,
			payload: true
		})

		const response = await axios.patch(`${baseUrl}/sickbay/records/${id}`, payload, { headers })

		dispatch({
			type: UPDATE_SICKBAY_RECORD,
			payload: response?.data?.data || response?.data
		})

		dispatch({
			type: SET_SUCCESS,
			payload: 'Sickbay record updated successfully'
		})
	} catch (error) {
		dispatch({
			type: SICKBAY_ERROR,
			error
		})
	}
}

export const fetchSickBayStats = (filterString) => async (dispatch) => {
	try {
		const headers = authHeader()

		let url = `${baseUrl}/sickbay/stats`

		if (filterString && filterString !== '') {
			url += `${url.includes('?') ? '&' : '?'}${filterString}`
		}

		dispatch({
			type: GETTING_SICKBAY_STATS,
			payload: true
		})

		const response = await axios.get(url, { headers })

		dispatch({
			type: GET_SICKBAY_STATS,
			payload: response?.data?.data || response?.data
		})
	} catch (error) {
		dispatch({
			type: SICKBAY_ERROR,
			error
		})
	}
}

export const clearCreatedSickBayRecord = () => async (dispatch) => {
	dispatch({
		type: CREATE_SICKBAY_RECORD,
		payload: null
	})
}

export const clearUpdatedSickBayRecord = () => async (dispatch) => {
	dispatch({
		type: UPDATE_SICKBAY_RECORD,
		payload: null
	})
}

